import { Grid, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { ApiProgress } from "../../Utilities/ApiProgress";
import { useProductSettingsContext } from "./context/ProductSettingsContext";
import { ProductSettingsDistributorGrid } from "./components/ProductSettingsDistributorGrid";
import InfoDialog from './dialogs/InfoDialog';
import ErrorDialog from './dialogs/ErrorDialog';
import FileUpload from "../../Components/FileUpload";

const getProductSettingsUploadTemplateCsv = () =>
    process.env.REACT_APP_ENABLE_IN_MARKET_DATE === 'true'
        ? 'distributor,sku,offeringStatus,fulfillmentMethod,directDistributor,palletQuantity,palletDivisor,unitWeight,inMarketDate\n'
        : 'distributor,sku,offeringStatus,fulfillmentMethod,directDistributor,palletQuantity,palletDivisor,unitWeight\n';

const ProductSettings = () => {
    const {
        dataLoaded,
        productDefaults,
    } = useProductSettingsContext();

    return (dataLoaded ? <Paper elevation={1} sx={{ padding: 2, margin: 2 }}>
        <Stack direction='column' spacing={1}>
            <Grid container>
                <Grid item xs={10}>
                    <Typography
                        variant='h4'>{productDefaults.brandFamily} {productDefaults.description} ({productDefaults.sku})</Typography>
                </Grid>
                <Grid item xs={2} direction="row" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <FileUpload
                        uploadUrl="api/products/productSettings"
                        buttonText="Upload Settings"
                        accept=".csv"
                        InfoDialogComponent={InfoDialog}
                        ErrorDialogComponent={ErrorDialog}
                        templateDownloadFileName="ProductSettingsUploadTemplate.csv"
                        templateDownloadTooltip="Download template"
                        getTemplateDownloadContent={getProductSettingsUploadTemplateCsv}
                    />
                </Grid>
            </Grid>
            <div style={{ width: "100%", height: "70vh" }}>
                <ProductSettingsDistributorGrid />
            </div>
        </Stack>
    </Paper> : <ApiProgress />)
}

export default ProductSettings;